import { ComponentsState, ErrorComponentsState } from "piral";

import { lazy } from "react";
import { Router, RouteSwitch } from "./routerV6";

const ShellLayout = lazy(() => import("./components/common/ShellLayout"));
const LoadingError = lazy(() => import("./components/common/LoadingError"));
const NotFound = lazy(() => import("./components/common/NotFound"));

export const errors: Partial<ErrorComponentsState> = {
  not_found: NotFound,
  loading: LoadingError,
};

export const layout: Partial<ComponentsState> = {
  Layout: ShellLayout,
  Router,
  RouteSwitch,
};
